"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryBuilderHelper = void 0;
const json_1 = require("./json");
class QueryBuilderHelper {
    /**
     * Converts from a raw query builder value to an enum value.
     * Note: This can be made smarter to capture failure conditions in the future,
     * but likely not a problem at the time of writing.
     *
     * @param value The number values for the in statement.
     *
     * @returns A string that is the sub query for the given set of values.
     */
    static rawEnumValueToEnum(value) {
        return value != undefined ? parseInt(value, 10) : undefined;
    }
    /**
     * Converts from a raw query builder value to an js object either via the column stored as a json or stored as a string.
     * Note: This can be made smarter to capture failure conditions in the future,
     * but likely not a problem at the time of writing.
     *
     * @param value The string/object/null value from the db.
     *
     * @returns An object or undefined based on what was stored/returned from typeorm raw query.
     */
    /**
     * Parses a raw PostgreSQL enum array string (e.g. `{1,2,3}`) returned by the TypeORM raw
     * query builder into a typed JavaScript array.
     *
     * @param value The raw string value from the query builder.
     * @returns An array of enum values, or undefined if the value is absent.
     */
    static rawEnumArrayToEnumArray(value) {
        if (value == undefined || value == null) {
            return undefined;
        }
        const inner = value.slice(1, -1);
        if (inner === "") {
            return [];
        }
        return inner.split(",").map((v) => parseInt(v, 10));
    }
    static jsonFieldToObject(value) {
        if (value == undefined) {
            return undefined;
        }
        if (typeof value == "string") {
            return (0, json_1.dateDeserialize)(value);
        }
        return value;
    }
}
exports.QueryBuilderHelper = QueryBuilderHelper;
